import { render, staticRenderFns } from "./ConfigLent.vue?vue&type=template&id=464e9128&"
import script from "./ConfigLent.vue?vue&type=script&lang=js&"
export * from "./ConfigLent.vue?vue&type=script&lang=js&"
import style0 from "./ConfigLent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports